import {
	Calendar01Icon,
	Certificate01Icon,
	DashboardSquare01Icon,
	DocumentValidationIcon,
	LayoutGridIcon,
	Location01Icon,
	Medal01Icon,
	Notification01Icon,
	Settings02Icon,
	UserCircleIcon,
	UserGroupIcon,
} from "@hugeicons/core-free-icons";

import type { IconSvgElement } from "@hugeicons/react";

import { isNavItemActive } from "./navigation";

export type SidebarNavItem = {
	key: string;
	label: string;
	href: string;
	icon: IconSvgElement;
	activePrefixes?: string[];
};

export type OrgNavItem = SidebarNavItem & {
	hrefSuffix: string;
	roles: string[];
};

export const PLAYER_NAV_ITEMS: SidebarNavItem[] = [
	{
		key: "dashboard",
		label: "Dashboard",
		href: "/dashboard",
		icon: DashboardSquare01Icon,
		activePrefixes: ["/dashboard"],
	},
	{
		key: "tournaments",
		label: "Tournaments",
		href: "/tournaments",
		icon: Calendar01Icon,
		activePrefixes: ["/tournaments", "/events", "/e/", "/t/"],
	},
	{
		key: "venues",
		label: "Venues",
		href: "/venues",
		icon: Location01Icon,
		activePrefixes: ["/venues", "/v/"],
	},
	{
		key: "results",
		label: "Results",
		href: "/me/results",
		icon: Medal01Icon,
		activePrefixes: ["/me/results"],
	},
	{
		key: "certificates",
		label: "Certificates",
		href: "/me/certificates",
		icon: Certificate01Icon,
		activePrefixes: ["/me/certificates"],
	},
	{
		key: "profile",
		label: "Profile",
		href: "/profile",
		icon: UserCircleIcon,
		activePrefixes: ["/profile"],
	},
];

export const ORG_NAV_ITEMS: OrgNavItem[] = [
	{
		key: "overview",
		label: "Overview",
		href: "",
		hrefSuffix: "",
		icon: LayoutGridIcon,
		roles: ["federation_admin", "tournament_operator", "member"],
	},
	{
		key: "org-tournaments",
		label: "Tournaments",
		href: "",
		hrefSuffix: "/tournaments",
		icon: Calendar01Icon,
		roles: ["federation_admin", "tournament_operator", "member"],
	},
	// {
	// 	key: "org-venues",
	// 	label: "Venues",
	// 	href: "",
	// 	hrefSuffix: "/venues",
	// 	icon: Location01Icon,
	// 	roles: ["federation_admin", "tournament_operator", "member"],
	// },
	{
		key: "staff",
		label: "Staff",
		href: "",
		hrefSuffix: "/staff",
		icon: UserGroupIcon,
		roles: ["federation_admin"],
	},
	{
		key: "applications",
		label: "Applications",
		href: "",
		hrefSuffix: "/staff/applications",
		icon: DocumentValidationIcon,
		roles: ["federation_admin"],
	},
];

export const FOOTER_NAV_ITEMS: SidebarNavItem[] = [
	{
		key: "notifications",
		label: "Notifications",
		href: "/notifications",
		icon: Notification01Icon,
		activePrefixes: ["/notifications"],
	},
	{
		key: "settings",
		label: "Settings",
		href: "/settings",
		icon: Settings02Icon,
		activePrefixes: ["/settings"],
	},
];

export function getOrgNavItems(districtSlug: string, role: string) {
	return ORG_NAV_ITEMS.filter((item) => item.roles.includes(role)).map(
		(item) => ({
			...item,
			href: `/dashboard/d/${districtSlug}${item.hrefSuffix}`,
			activePrefixes: [
				`/dashboard/d/${districtSlug}${item.hrefSuffix || "/__exact__"}`,
			],
		}),
	);
}

export function isSidebarNavItemActive(
	pathname: string | null,
	item: SidebarNavItem,
) {
	if (!pathname) return false;

	// For exact district overview match (e.g. /dashboard/d/hyderabad with no suffix)
	if (item.activePrefixes?.some((p) => p.endsWith("/__exact__"))) {
		const exactPath = item.activePrefixes[0]!.replace("/__exact__", "");
		return pathname === exactPath;
	}

	return isNavItemActive(pathname, {
		key: item.key,
		label: item.label,
		href: { pathname: item.href },
		pathname: item.href,
		icon: item.icon,
		activePrefixes: item.activePrefixes,
	});
}

export function extractDistrictSlug(pathname: string): string | null {
	const match = pathname.match(/^\/dashboard\/d\/([^/]+)/);
	return match?.[1] ?? null;
}
